import { lazy } from 'react';

export const BncFraude = lazy(
    () => import(/* webpackChunkName: "theme_bnc-fraude" */ './BncFraudeTheme'),
);

export const TourismeLaurentides = lazy(
    () => import(/* webpackChunkName: "theme_tourisme-laurentides" */ './TourismeLaurentidesTheme'),
);

export const Remax = lazy(() => import(/* webpackChunkName: "theme_remax" */ './RemaxTheme'));

export const JeuAideMachine = lazy(
    () => import(/* webpackChunkName: "theme_jeu-aide-machine" */ './JeuAideMachineTheme'),
);

export const FranceDonation = lazy(
    () => import(/* webpackChunkName: "theme_france-donation" */ './FranceDonationTheme'),
);

export const SaqRouteProducteurs = lazy(
    () =>
        import(/* webpackChunkName: "theme_saq-route-producteurs" */ './SaqRouteProducteursTheme'),
);

export const TourismeMontrealVacances = lazy(
    () =>
        import(
            /* webpackChunkName: "theme_tourisme-montreal-vacances" */ './TourismeMontrealVacancesTheme'
        ),
);

export const Fizz = lazy(() => import(/* webpackChunkName: "theme_fizz" */ './FizzTheme'));

export const Uniprix = lazy(() => import(/* webpackChunkName: "theme_uniprix" */ './UniprixTheme'));

export const MesQuebec = lazy(
    () => import(/* webpackChunkName: "theme_mes-quebec" */ './MesQuebecTheme'),
);

export const Sherbrooke = lazy(
    () => import(/* webpackChunkName: "theme_sherbrooke" */ './SherbrookeTheme'),
);

export const Alto = lazy(() => import(/* webpackChunkName: "theme_alto" */ './AltoTheme'));

export const Educepargne = lazy(
    () => import(/* webpackChunkName: "theme_sherbrooke" */ './EducepargneTheme'),
);

export const Tv5 = lazy(() => import(/* webpackChunkName: "theme_tv5" */ './Tv5Theme'));

export const QuizTv5Serie = lazy(
    () => import(/* webpackChunkName: "theme_quiz_tv5_serie" */ './Tv5Theme'),
);

export const Cfpbj = lazy(() => import(/* webpackChunkName: "theme_cfpbj" */ './CfpbjTheme'));

export const QuizRetraiteQuebecFinances = lazy(
    () =>
        import(
            /* webpackChunkName: "theme_quiz_retraite_quebec_finances" */ './RetraiteQuebecTheme'
        ),
);

export const QuizUniprixSanteAdulte = lazy(
    () =>
        import(
            /* webpackChunkName: "theme_quiz_uniprix_sante_adulte" */ './QuizUniprixSanteAdulteTheme'
        ),
);

export const QuizToyotaFilm = lazy(
    () => import(/* webpackChunkName: "theme_quiz_toyota_film" */ './QuizToyotaFilmTheme'),
);
